<template>
  <AccountingPage title="Décaissements">
    <DisbursementForAccountingTable/>
  </AccountingPage>
</template>

<script>
import AccountingPage from "@/accounting/components/AccountingPage.vue";
import DisbursementForAccountingTable from "@/accounting/components/tables/DisbursementForAccountingTable.vue";

export default {
  name: 'AccountingDisbursementView',
  components: {
    DisbursementForAccountingTable,
    AccountingPage,
  },
}
</script>
